import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { TranslateModule } from '@ngx-translate/core';
import { ArcGisMapComponent } from '../arcgis-map/arcgis-map.component';
import { EntityPageModule } from '../entity-page/entity-page.module';
import { ImageGalleryModule } from '../image-gallery/image-gallery.module';
import { AccordionPanelModule } from '../shared/components/accordion-panel/accordion-panel.module';
import { ConservationArchiveDocumentComponent } from './conservation-archive-document.component';
import { ConservationArchiveDocumentDetailsComponent } from './conservation-archive-document-details/conservation-archive-document-details.component';

@NgModule({
    imports: [
        CommonModule,
        ButtonModule,
        TranslateModule,
        ArcGisMapComponent,
        EntityPageModule,
        ImageGalleryModule,
        AccordionPanelModule,
    ],
    declarations: [ConservationArchiveDocumentComponent, ConservationArchiveDocumentDetailsComponent],
    exports: [ConservationArchiveDocumentComponent],
})
export class ConservationArchiveDocumentModule {}
